module.exports = __webpack_public_path__ + "static/media/qualidade_icon.4d868925.webp";